import { Preferences as CapacitorPreferences } from "@capacitor/preferences"
import { registerIngenicoPlugin } from "./utils/registerIngenicoPlugin"

export type IPreferencesPlugin = {
  get: (payload: {
    key: string
  }) => Promise<{ value: string | null }>
  set: (paylod: {
    key: string
    value: string
  }) => Promise<void>
}

export const IPreferences: IPreferencesPlugin =
  import.meta.env.VITE_PLATFORM === "ingenicoNerpay"
    ? registerIngenicoPlugin<IPreferencesPlugin>(
        "IPreferencesPlugin"
      )
    : CapacitorPreferences
